import script from "./Personal.vue?vue&type=script&setup=true&lang=ts"
export * from "./Personal.vue?vue&type=script&setup=true&lang=ts"

import "./Personal.vue?vue&type=style&index=0&id=2af638be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2af638be"]])

export default __exports__